import { cva } from '@vizit/theme';
import { FontFamily, TextColor, TextEllipsis, TextSize, TextVariant, TextWeight } from './types';

/**
 * The classes for the Text component. These are used to style other
 * text based components and Vite does not like dynamic exports with components
 * exports.
 */
export const textClasses = cva({
  base: 'box-border',
  variants: {
    color: {
      [TextColor.Primary]: 'text-primary',
      [TextColor.Secondary]: 'text-secondary',
      [TextColor.Tertiary]: 'text-tertiary',
      [TextColor.Quaternary]: 'text-quaternary',
      [TextColor.Danger]: 'text-error-600',
      [TextColor.Inherit]: 'text-inherit',
    },
    ellipsis: {
      [TextEllipsis.Single]: 'truncate',
      [TextEllipsis.Multiple]: 'line-clamp-[--text-line-clamp]',
      [TextEllipsis.None]: '',
    },
    fontFamily: {
      [FontFamily.Sans]: 'font-sans',
      [FontFamily.Serif]: 'font-serif font-light',
      [FontFamily.Mono]: 'font-mono',
    },
    size: {
      [TextSize.Xxs]: 'text-xxs',
      [TextSize.Xs]: 'text-xs',
      [TextSize.Sm]: 'text-sm',
      [TextSize.Md]: 'text-md',
      [TextSize.Lg]: 'text-lg',
      [TextSize.Xl]: 'text-xl',
    },
    weight: {
      [TextWeight.Bold]: 'font-bold',
      [TextWeight.Semibold]: 'font-semibold',
      [TextWeight.Medium]: 'font-medium',
      [TextWeight.Regular]: 'font-normal',
    },
    /**
     * Semantic text variants that combine font-family, size, and weight.
     * When variant is specified, it takes precedence over individual size/weight/fontFamily props.
     */
    variant: {
      [TextVariant.HeaderMd]: 'font-serif text-display-md font-light',
      [TextVariant.LgMedium]: 'font-sans text-lg font-medium',
      [TextVariant.MdMedium]: 'font-sans text-md font-medium',
      [TextVariant.MdRegular]: 'font-sans text-md font-normal',
      [TextVariant.SmSemibold]: 'font-sans text-sm font-semibold',
      [TextVariant.SmMedium]: 'font-sans text-sm font-medium',
      [TextVariant.SmRegular]: 'font-sans text-sm font-normal',
      [TextVariant.XsSemibold]: 'font-sans text-xs font-semibold',
      [TextVariant.XsMedium]: 'font-sans text-xs font-medium',
      [TextVariant.XsRegular]: 'font-sans text-xs font-normal',
      [TextVariant.Label]: 'font-sans text-xxs font-medium uppercase',
      [TextVariant.MonoXs]: 'font-mono text-xxs font-normal leading-[120%]',
      [TextVariant.MonoSm]: 'font-mono text-xs font-medium leading-[120%]',
      [TextVariant.MonoMd]: 'font-mono text-display-xs font-bold leading-[120%]',
      [TextVariant.MonoLg]: 'font-mono text-display-md font-bold leading-[120%]',
      [TextVariant.MonoXl]: 'font-mono text-[42px] font-bold leading-[120%]',
      [TextVariant.MonoXxl]: 'font-mono text-[48px] font-bold leading-[120%]',
    },
  },
  defaultVariants: {
    color: TextColor.Primary,
    ellipsis: TextEllipsis.Single,
    fontFamily: FontFamily.Sans,
  },
});
